import { ChevronDown } from "lucide-react";
import { useState } from "react";

const MODELS = [
  { id: "zeus-1", name: "Zeus-1", desc: "Fast & capable" },
  { id: "zeus-1-pro", name: "Zeus-1 Pro", desc: "Advanced reasoning" },
  { id: "zeus-vision", name: "Zeus Vision", desc: "Image understanding" },
];

export function ModelSelector() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(MODELS[0]);

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-xl hover:bg-surface-hover transition-colors text-sm font-medium text-foreground"
      >
        {selected.name}
        <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute top-full left-0 mt-1 z-50 w-56 rounded-xl border border-border bg-popover p-1 shadow-xl shadow-black/30 animate-fade-in">
            {MODELS.map((m) => (
              <button
                key={m.id}
                onClick={() => {
                  setSelected(m);
                  setOpen(false);
                }}
                className={`w-full flex flex-col items-start px-3 py-2 rounded-lg text-left transition-colors ${
                  selected.id === m.id
                    ? "bg-surface-active text-foreground"
                    : "hover:bg-surface-hover text-foreground/80"
                }`}
              >
                <span className="text-sm font-medium">{m.name}</span>
                <span className="text-xs text-muted-foreground">{m.desc}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
